import { Directive } from '@angular/core';

@Directive({
  selector: '[uniSuffix]',
})
export class UniSuffixDirective {}
